import React from 'react';
import { Container, Row, Col, Table } from 'reactstrap';

function Education(){
    return(
        <React.Fragment>
            <Container className="container" id="education">
            <h1 className="text-center">Educational Details</h1>
            <hr/>
                <Row>
                    <Col className="headline">
                        <p>I have always focused on overall growth of myself.
                           I always participated in sports activities during my college 
                           and learning about web development since my second year.
                           However i never did all of these at the cost of my curricular activities.
                           More deatils about my grades are in the following table.
                        </p>
                    </Col>       
                </Row>
                <Row>
                <Table striped bordered hover className="education">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Degree</th>
                    <th>Year</th>
                    <th>College</th>
                    <th>Marks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Bachelors of Engineering</td>
                    <td>2017-2021</td>
                    <td>Sinhgad Institute of Technology</td>
                    <td>7.65 CGPA</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Higher Secondary</td>
                    <td>2017</td>
                    <td>Vigyan Sanjivani Central College</td>
                    <td>74.6 %</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Senior Secondary</td>
                    <td>2015</td>
                    <td>Vigyan Sanjivani Central College</td>
                    <td>9.6 CGPA</td>
                  </tr>
                </tbody>
              </Table>
                </Row>
            </Container>
        </React.Fragment>
    )
}

export default Education;